import { ORDER_STATUS_ACCEPTED } from '../../utils/orderUtils'

const getters = {
  acceptedOrders: (state) => state.activeOrders.filter((o) => o.status === ORDER_STATUS_ACCEPTED),
}

export default getters
